const settlementOrderLineTypes = {
	WITHDRAWAL: 'withdrawal',
	DEPOSIT: 'deposit'
};

module.exports = settlementOrderLineTypes;
